"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentParticipantTypeEnum = void 0;
var IncidentParticipantTypeEnum;
(function (IncidentParticipantTypeEnum) {
    IncidentParticipantTypeEnum["AGGRESSOR"] = "Aggressor";
    IncidentParticipantTypeEnum["WITNESS"] = "Witness";
    IncidentParticipantTypeEnum["VICTIM"] = "Victim";
})(IncidentParticipantTypeEnum || (exports.IncidentParticipantTypeEnum = IncidentParticipantTypeEnum = {}));
